import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=72fde3db&scoped=true"
import script from "./assistant.vue?vue&type=script&lang=js"
export * from "./assistant.vue?vue&type=script&lang=js"
import style0 from "./assistant.vue?vue&type=style&index=0&id=72fde3db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fde3db",
  null
  
)

export default component.exports